<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id');
		}
	},
	streamAlive: {
		type: Boolean
	},
})

const emit = defineEmits({
	'set-live-stream-countdown': () => true,
	'live-stream-abr-changed': () => true
})
const childViewList = ref([
	{
		streamType: 'live',
		name: 'Notifications',
		viewName: 'StreamsManageNotifications'
	},
	{
		streamType: 'live',
		name: 'Webhooks',
		viewName: 'StreamsManageWebhooks'
	},
	{
		streamType: 'restream',
		name: 'Notifications',
		viewName: 'StreamsManageNotifications'
	},
	{
		streamType: 'restream',
		name: 'Webhooks',
		viewName: 'StreamsManageWebhooks'
	},
])

const childViews = computed(() => {
	return (props.stream && childViewList.value.filter(view => {
		const isIncluded = view.streamType === props.stream?.type;
		return isIncluded && view.validate ? view.validate(props.stream) : isIncluded;
	}));
}
)
const liveStreamCountdownSelected = (d) => {
	emit('set-live-stream-countdown', d)
}
const liveStreamAbrChanged = (d) => {
	emit('live-stream-abr-changed', d);
}
const isActive = (name) => {
	return route.name === name
}
</script>
<template>
	<div class="inline-flex items-center gap-1 bg-surface-2 rounded-lg p-1">
		<router-link v-for="(viewItem, index) in childViews" :key="index" :to="{ name: viewItem.viewName }"
			class="capitalize text-sm font-medium text-surface-8 hover:text-white hover:no-underline hover:bg-surface-3 px-3 py-1.5 rounded-md text-nowrap transition-colors"
			:class="{ '!bg-surface-4 !text-white shadow-sm': isActive(viewItem.viewName) }">
			{{ viewItem.name }}
		</router-link>
	</div>
	<div class="tab-content relative mt-4">
		<router-view :stream="stream" :stream-alive="streamAlive" @set-live-stream-countdown="liveStreamCountdownSelected"
			@live-stream-abr-changed="liveStreamAbrChanged" />
	</div>

</template>

<style scoped></style>
